import { Node, mergeAttributes } from '@tiptap/core';

export const ImageCaptionNode = Node.create({
  name: 'imageCaption',
  group: 'block',
  content: 'inline*',

  addAttributes() {
    return {
      caption: {
        default: '',
        parseHTML: (el) => el.getAttribute('data-caption') || '',
        renderHTML: (attrs) => ({ 'data-caption': attrs['caption'] }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'figcaption' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'figcaption',
      mergeAttributes(HTMLAttributes, {
        class: 'image-caption',
        style: 'text-align: center; font-style: italic; color: #666; font-size: 0.875em; margin-top: 0.5em;',
      }),
      0,
    ];
  },
});
